import { fansupportPrivate } from "../index";
/**
 * This function sends a POST request to change the password of the user.
 *
 * @param {string} currentPassword - The current password of the user.
 * @param {string} newPassword - The new password of the user.
 * @param {string} confirmPassword - The confirmation of the new password.
 * @return {Promise} A Promise that resolves to the response data or rejects with an error.
 */
export const postChangePassword = async ( currentPassword, newPassword, confirmPassword ) => {
    //  console.log("payload", currentPassword, newPassword, confirmPassword);
    try {
        const data =  fansupportPrivate.post('/identity/change-password', {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
    })
        return data;

    } catch (error) {
        console.log("postCampaignError",error);
    }
}